<!-- 嵌入式-报警管理 -->
<template>
  <el-dialog
    title="实施信息"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="80%"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="toolbar">
      <el-button type="primary" @click="onCreateClick" v-permission="'dci_station_implementation-POST'">
        <i class="fas fa-plus"></i> 新增
      </el-button>
    </div>

    <div id="app">
      <el-table
        :data="implementationList"
        v-loading="loading"
        ref="tableItems"
      >
        <el-table-column
          type="selection"
          width="45"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column
          type="index"
          :index="pager.size * (pager.page - 1) + 1"
          :width="
            Math.max(40, (pager.size * pager.page).toString().length * 12)
          "
        />
        <el-table-column prop="ImplementationAt" label="实施日期" width="120">
          <template scope="scope">
            <span>{{
              $sys.dateFormat(scope.row.ImplementationAt, "Y-m-d")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ImplementationPerson"
          label="实施人员"
          width="100"
        ></el-table-column>
        <el-table-column prop="ImplementationType" label="实施方式" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ImplementationType === 0" type="warning">
              现场实施
            </el-tag>
            <el-tag v-else> 远程实施 </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ImplementationContent" label="实施内容">
          <template slot-scope="{ row }">
            <!-- <span>{{ row.ImplementationContent }}</span> -->
            <el-tag
              v-for="ele in row.ImplementationContent"
              :key="ele"
              style="margin-right: 5px;"
              type="success"
              >{{ implementationContentList.find(e=> e.Key === ele)
              && implementationContentList.find(e=> e.Key === ele).Value }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="ImplementationDest"
          label="实施目的地"
        ></el-table-column>
        <el-table-column prop="ImplementationRemark" label="实施备注" show-overflow-tooltip
          ><template scope="scope">
            <span>{{ scope.row.ImplementationRemark }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" prop="CreatedUser.Name" width="100" />
        <el-table-column label="创建日期" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.CreatedAt">{{
              $sys.dateFormat(row.CreatedAt, "Y-m-d")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90">
          <template scope="scope">
            <div class="text-nowrap">
              <el-button
                type="primary"
                size="small"
                title="编辑"
                v-permission="'dci_station_implementation-PUT'"
                style="width: 33px"
                @click="onDetailItem(scope.row)"
              >
                <i class="fas fa-edit"></i>
              </el-button>
              <el-button
                type="danger"
                size="small"
                title="删除"
                @click="onDeleteItem(scope.row.ID)"
                v-permission="'dci_station_implementation-DELETE'"
                style="width: 33px"
              >
                <i class="fas fa-trash"></i>
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>
    <implementation-form
      v-model="implementationitem"
      :visible.sync="implementationVisible"
      @form:saved="getImplementationList"
    />
  </el-dialog>
</template>
<script>
import ImplementationForm from "./implementationForm.vue";

export default {
  components: {
    ImplementationForm
  },
  data() {
    return {
      implementationList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      implementationitem: {},
      implementationVisible: false,
      implementationContentList: [{Key: 0, Value: "常规联网"},{Key: 1, Value: "流程调试"},{Key: 2, Value: "开发调试"}],
    };
  },
  props: {
    value: Object,
    visible: Boolean,
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
      this.getImplementationList();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("form:done", true);
      this.$emit("cancel");
    },
    getImplementationList() {
      this.loading = true;
      this.$axios
        .get(`dci/product/implementation/list`, {
          params: {
            where: {
              DciProductID: this.item.ID,
            },
            with: ["CreatedUser"],
            ...this.pager,
            order: ["-created_at"],
          },
        })
        .then(
          (response) => {
            this.implementationList = response.data.data;
            this.pager = _.pick(response.data, "size", "page", "total");
          },
          (response) => {
            this.$sys.alarmResponse(response);
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getImplementationList();
    },
    
    //新增
    onCreateClick() {
      this.implementationitem = this.getEmptyItem();
      this.implementationitem.DciProductID = this.item.ID;
      this.implementationVisible = true;
    },
    // 编辑
    onDetailItem(row) {
      this.implementationitem = row;
      this.implementationVisible = true;
    },
    // 删除设备
    onDeleteItem (id) {
      this.$confirm('请确认要删除该实施信息?', '删除实施信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => 
          this.$axios.delete(`dci/product/implementation/${id}`)
        )
        .then(() => {
          this.getImplementationList();
          this.$message.success("实施信息删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {
        ImplementationAt: null, //实施日期
        ImplementationPerson: "", //实施人员
        ImplementationType: 0, //实施方式 0.现场 1.远程
        ImplementationContent: "", //实施内容
        ImplementationDest: "", //实施目的地
        ImplementationRemark: "", //实施备注
        ImplementationAttachments: [], //实施附件
      };
    },

  },
};
</script>
<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
  .el-table {
    // 看这里！！！！！！！！！！！！！！！！！！！！！！！！！！！！
    // 深度选择器，去除默认的padding
    /deep/ th {
      padding: 0 0 10 0;
      font-size: larger;
    }
  }
}
</style>